/**
 * Hungarian forint.
 */
export var HUF = {
  code: 'HUF',
  base: 10,
  exponent: 2
};